import { createAction, handleActions } from "redux-actions";
import { deleteVocabularyAPI, getVocabulariesAPI } from "@modules/apis/vocabularies";
import extractApiError from "@utils/extract-api-error";

const initialState = {
    data: null,
    pending: false,
    error: null,
    isCardView: true,
};

const GET_VOCABULARIES_PENDING = "GET_VOCABULARIES_PENDING";
const GET_VOCABULARIES_SUCCESS = "GET_VOCABULARIES_SUCCESS";
const GET_VOCABULARIES_FAILURE = "GET_VOCABULARIES_FAILURE";
const DELETE_VOCABULARY_SUCCESS = "DELETE_VOCABULARIES_SUCCESS";
const RESET_VOCABULARIES = "RESET_VOCABULARIES";

export default handleActions(
    {
        [GET_VOCABULARIES_PENDING]: (state) => {
            return { ...state, data: null, pending: true, error: null };
        },
        [GET_VOCABULARIES_SUCCESS]: (state, action) => {
            return { ...state, data: action.payload, pending: false };
        },
        [GET_VOCABULARIES_FAILURE]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: extractApiError(action.payload),
            };
        },
        [RESET_VOCABULARIES]: (state) => {
            return { ...state, data: null, pending: false, error: null };
        },
    },
    initialState,
);

export const resetVocabularies = createAction(RESET_VOCABULARIES);

export const getVocabularies = (params) => async (dispatch, getState) => {
    const { stage, project, vocabularies } = getState();

    try {
        dispatch({
            type: GET_VOCABULARIES_PENDING,
        });
        const { data } = await getVocabulariesAPI(stage.id, stage.endpoint, project.id, params);

        dispatch({
            type: GET_VOCABULARIES_SUCCESS,
            payload: params.nextToken ? [...vocabularies.data, ...data.results] : data.results,
        });

        return data.nextToken;
    } catch (error) {
        dispatch({ type: GET_VOCABULARIES_FAILURE, payload: error });
        throw null;
    }
};

export const deleteVocabulary = (vocabularyId) => async (dispatch, getState) => {
    const { stage, project } = getState();

    try {
        const { data } = await deleteVocabularyAPI(stage.id, stage.endpoint, project.id, vocabularyId);

        dispatch({
            type: DELETE_VOCABULARY_SUCCESS,
            payload: vocabularyId,
        });
    } catch (error) {
        throw error;
    }
};
